import { Badge, Tab, Tabs } from "@mui/material";

import { OperationRecordsByTab, OperationTab } from "../types";

const tabs: Array<{ value: OperationTab; label: string }> = [
  { value: "requests", label: "Stock Requests" },
  { value: "transfers", label: "Transfers" },
  { value: "receipts", label: "Goods Receipts" },
  { value: "issues", label: "Spare Issues" },
  { value: "returns", label: "Spare Returns" },
  { value: "spareUsage", label: "Spare Usage" },
  { value: "invoices", label: "Invoices" },
];

interface OperationsTabsProps {
  value: OperationTab;
  records: OperationRecordsByTab;
  onChange: (tab: OperationTab) => void;
}

const OperationsTabs = ({ value, records, onChange }: OperationsTabsProps) => (
  <Tabs
    value={value}
    onChange={(_, nextTab) => onChange(nextTab)}
    variant="scrollable"
    scrollButtons="auto"
    sx={(theme) => ({
      px: 1,
      bgcolor: theme.palette.mode === "dark" ? "#111b2d" : "background.paper",
      borderRadius: "12px 12px 0 0",
      borderBottom: "1px solid",
      border: "1px solid",
      borderColor: theme.palette.mode === "dark" ? "#2a3953" : "divider",
      "& .MuiTab-root": {
        minHeight: 52,
        textTransform: "none",
        fontWeight: 800,
        fontSize: "0.78rem",
      },
      "& .MuiBadge-badge": {
        fontWeight: 800,
        minWidth: 20,
        height: 20,
        right: -14,
        top: 1,
      },
    })}
  >
    {tabs.map((tab) => (
      <Tab
        key={tab.value}
        value={tab.value}
        label={
          <Badge color="primary" badgeContent={records[tab.value].length} sx={{ pr: 1.5 }}>
            {tab.label}
          </Badge>
        }
      />
    ))}
  </Tabs>
);

export default OperationsTabs;
